import { t as uiText } from '../../i18n';
import React, { useState } from 'react';
import { buildDynamicEmbedCode, buildDynamicEmbedCodeGtm } from './dynamicEmbedCode';
import EmbedInstallGuide from './EmbedInstallGuide';
import './DynamicEmbedCodeBlock.css';

type EmbedCodeTab = 'direct' | 'gtm';

interface DynamicEmbedCodeBlockProps {
  token: string;
  publishId: string;
  /** 登録済みのサイト。設置ガイドに「ここでだけ動く」として表示する。 */
  allowedOrigins?: string[];
}

const DynamicEmbedCodeBlock: React.FC<DynamicEmbedCodeBlockProps> = ({ token, publishId, allowedOrigins }) => {
  const [tab, setTab] = useState<EmbedCodeTab>('direct');
  const [copied, setCopied] = useState(false);
  const code = tab === 'gtm'
    ? buildDynamicEmbedCodeGtm({ token, publishId })
    : buildDynamicEmbedCode({ token, publishId });

  const copy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="dynamic-embed-code">
      <div className="dynamic-embed-code__tabs">
        <button
          type="button"
          className={`dynamic-embed-code__tab${tab === 'direct' ? ' dynamic-embed-code__tab--active' : ''}`}
          onClick={() => setTab('direct')}
        >
          {uiText("Direct embed")}
        </button>
        <button
          type="button"
          className={`dynamic-embed-code__tab${tab === 'gtm' ? ' dynamic-embed-code__tab--active' : ''}`}
          onClick={() => setTab('gtm')}
        >
          {uiText("Recommended for GTM")}
        </button>
      </div>
      <div className="dynamic-embed-code__frame">
        <pre className="dynamic-embed-code__pre">
          <code>{code}</code>
        </pre>
        <button type="button" className={`dynamic-embed-code__copy${copied ? ' dynamic-embed-code__copy--done' : ''}`} onClick={copy}>
          {copied ? uiText("✓ Copied") : uiText("📋 Copy")}
        </button>
      </div>
      <EmbedInstallGuide kind={tab} allowedOrigins={allowedOrigins} />
    </div>
  );
};

export default DynamicEmbedCodeBlock;
